import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=97eb1086&"
import script from "./base-checkbox.vue?vue&type=script&lang=js&"
export * from "./base-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports